import { render, staticRenderFns } from "./FechaSeccion.vue?vue&type=template&id=a3f057f4"
import script from "./FechaSeccion.vue?vue&type=script&lang=js"
export * from "./FechaSeccion.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports